import api from './api';

export const companyService = {
    getAllCompanies: async () => {
        const response = await api.get('/companies');
        return response.data;
    },

    getCompany: async (id) => {
        const response = await api.get(`/companies/${id}`);
        return response.data;
    }
};
